import React from "react";
import { Formik } from "formik";
import { Button, CircularProgress, TextField, Typography, withStyles, FormControl, Select, InputLabel, MenuItem, Chip } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

const SecurazeSolutionForm = (props) => {
    const { classes, translations, initialValues, formSettings, isEdit, handleSubmit, supportedClientTypes } = props;

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={formSettings.Validation}
            enableReinitialize
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
                setSubmitting(false);
            }}>
            {formikProps => {
                const { values, isValid, dirty, errors, touched, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue } = formikProps;
                return (
                    <form onSubmit={handleSubmit}>
                        <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                        <TextField
                            name="Key"
                            value={values.Key}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!(errors.Key && touched.Key)}
                            placeholder={translations['key'] || 'Key'}
                            label={translations['key'] || 'Key'}
                            margin={"dense"}
                            fullWidth={true}
                            disabled={isEdit ? true : false}
                        />
                        <TextField
                            name="LongName"
                            value={values.LongName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!(errors.LongName && touched.LongName)}
                            placeholder={translations['long_name'] || 'Long name'}
                            label={translations['long_name'] || 'Long name'}
                            margin={"dense"}
                            fullWidth={true}
                        />
                        <TextField
                            name="ShortName"
                            value={values.ShortName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!(errors.ShortName && touched.ShortName)}
                            placeholder={translations['short_name'] || 'Short name'}
                            label={translations['short_name'] || 'Short name'}
                            margin={"dense"}
                            fullWidth={true}
                        />
                        <FormControl className={classes.formControl} margin={"dense"}>
                            <InputLabel shrink>{translations['dedicated_for'] || 'Dedicated for'}</InputLabel>
                            <Select  
                            name="DedicatedFor"
                            label={translations['dedicated_for'] || 'Dedicated for'}
                            value={values.DedicatedFor}
                            margin={"dense"}
                            onChange={handleChange}
                            >
                                <MenuItem key={"all"} value={"all"}>
                                    {translations['all'] || 'All'}
                                </MenuItem>
                                <MenuItem key={"magnetic"} value={"magnetic"}>
                                    {translations['magnetic'] || 'Magnetic'}
                                </MenuItem>
                                <MenuItem key={"flash"} value={"flash"}>
                                    {translations['flash'] || 'Flash'}
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            name="Description"
                            value={values.Description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!(errors.Description && touched.Description)}
                            placeholder={translations['description'] || 'Description'}
                            label={translations['description'] || 'Description'}
                            margin={"dense"}
                            fullWidth={true}
                            multiline
                        />
                        <Autocomplete 
                            name={"SupportedClientTypeIDs"}
                            multiple
                            id="SupportedClientTypesMultiSelect"
                            options={supportedClientTypes || []}
                            getOptionLabel={(option) => option.label}
                            filterSelectedOptions
                            value={values.SupportedClientTypeIDs}
                            onChange={(_, value) => setFieldValue('SupportedClientTypeIDs', value)}
                            onBlur={handleBlur}
                            renderInput={(params) => (
                                <TextField {...params} variant="standard" fullWidth={true} label={`${translations["supported_client_types"] || "Supported client types"}`} />
                            )}
                            renderTags={(value, getTagProps) => (
                                value.map((option, index) => (
                                    <Chip label={option.label} {...getTagProps({ index })} />
                                ))
                            )}
                        />
                        {formSettings.ButtonSubmit &&
                            <Button
                                className={classes.submit}
                                variant="contained"
                                color={formSettings.ButtonSubmit.Color}
                                type="submit"
                                disabled={!(isValid && dirty) || isSubmitting}
                            >
                                {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                            </Button>}
                    </form>
                )
            }}
        </Formik>
    )
}

export default withStyles(styles, { withTheme: true })(SecurazeSolutionForm);